module.exports = __webpack_public_path__ + "img/ring_y_e_null_null@3x.b4289c42.png";